import React, { useEffect } from 'react'
import DateFnsUtils from '@date-io/date-fns';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
    DatePicker,
} from '@material-ui/pickers';
import { isValid } from 'date-fns';
import { az, enUS, ru } from "date-fns/locale";
import { translate } from 'react-i18next';

function DatePickerInput(props) {
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [error, setError] = React.useState(props.error);

    const handleDateChange = (date) => {
        if ((date && !isValid(date)) || !date) {
            setError(true);
            setSelectedDate(null);
            props.updateDate(props.name, null);
        } else {
            setError(false);
            setSelectedDate(date);
            props.updateDate(props.name, date);
        }
    };
    useEffect(() => { setError(props.error) }, [props.error])
    const { i18n, t } = props;
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={i18n.language == "ru" ? ru : i18n.language == 'en' ? enUS : az}>
            <KeyboardDatePicker
                className="dashboard-payment-container-data-section-content-container-form-input dashboard-payment-container-data-section-content-container-form-input__whole"
                placeholder={t("Daxil edin və ya təqvimdən seçin")}
                format="dd.MM.yyyy"
                disabled={props.readOnly}
                value={isValid(props.value) ? props.value : null}
                minDate={props.startDate ? props.startDate : undefined}
                maxDate={props.endDate ? props.endDate : undefined}
                cancelLabel={t('cancel')}
                okLabel={t('ok')}
                disablePast
                error={error}
                onChange={handleDateChange}
                keyboardbuttonprops={{
                    'aria-label': 'change date',
                }}
                helperText={false}
                keyboardIcon={
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M14 6.66671H2M10.6667 1.33337V4.00004M5.33333 1.33337V4.00004M5.2 14.6667H10.8C11.9201 14.6667 12.4802 14.6667 12.908 14.4487C13.2843 14.257 13.5903 13.951 13.782 13.5747C14 13.1469 14 12.5868 14 11.4667V5.86671C14 4.7466 14 4.18655 13.782 3.75873C13.5903 3.3824 13.2843 3.07644 12.908 2.88469C12.4802 2.66671 11.9201 2.66671 10.8 2.66671H5.2C4.0799 2.66671 3.51984 2.66671 3.09202 2.88469C2.71569 3.07644 2.40973 3.3824 2.21799 3.75873C2 4.18655 2 4.7466 2 5.86671V11.4667C2 12.5868 2 13.1469 2.21799 13.5747C2.40973 13.951 2.71569 14.257 3.09202 14.4487C3.51984 14.6667 4.0799 14.6667 5.2 14.6667Z" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                }
            />
        </MuiPickersUtilsProvider>
    )
}

export default translate("translation")(DatePickerInput);